"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        /**
         * Framework class for message data
         * @internal
         */
        var Message = /** @class */ (function () {
            function Message() {
                var _this = this;
                /**
                 * function to open the prefix panel
                 * @internal
                 */
                this.ExecuteHyperlink = function () {
                    var form;
                    if (_this.isStaticAction) {
                        form = $dyn.context($dyn.shell.getActiveForm());
                    }
                    else if (_this.targetForm) {
                        form = _this.targetForm;
                    }
                    if (form && form.ExecuteMessageAction) {
                        $dyn.callFunction(form.ExecuteMessageAction, form, [_this.messageId]);
                    }
                };
                this.ActionMessageText = "";
                this.isStaticAction = false;
                this.text = "";
                this.originType = messaging.OriginType.InfoLog;
                this.isMessage = true;
                this.isAlert = false;
                this.isWatchDog = false;
                this.ShowExtraMessageText = $dyn.observable(false);
                this.statusIcon = $dyn.computed(function () {
                    return $dyn.util.enumName(_this.type, $dyn.messaging.MessageType);
                });
                this.ShowActionMessageLink = $dyn.computed(function () {
                    return _this.messageId && _this.ActionMessageText !== "";
                });
                this.ShowStaticActionMessageLink = $dyn.computed(function () {
                    return _this.ShowActionMessageLink() && _this.isStaticAction;
                });
                /**
                 * Called by $dyn.ui.link
                 * If false, link message will still be shown
                 * ShowActionMessageLink & ShowStaticActionMessageLink determine link message visibility
                 */
                this.showLink = $dyn.computed(function () {
                    return _this.ShowActionMessageLink();
                });
            }
            /**
             * gets the message icon type
             * @internal
             * @return the icon type string 'info', 'warning' or 'error'
             */
            Message.prototype.getMessageIconType = function () {
                if (this.type === messaging.MessageType.information) {
                    return "Info";
                }
                else if (this.type === messaging.MessageType.warning ||
                    this.type === messaging.MessageType.controlValidation ||
                    this.type === messaging.MessageType.fieldValidation ||
                    this.type === messaging.MessageType.systemMaintenance) {
                    return "Warning";
                }
                else {
                    return "Error";
                }
            };
            /**
             * gets the related control for the message if there is one
             * @internal
             * @return the $dyn control the message is associated with or undefined
             */
            Message.prototype.FindRelatedControl = function () {
                var foundControl = this.relatedControl ? this.relatedControl : null;
                if (foundControl === null) {
                    var foundFormElement = $("[data-dyn-formid='" + this.formUniqueId + "']");
                    if (foundFormElement.length > 0) {
                        foundControl = $dyn.ui.findControl(this.targetName, foundFormElement[0]);
                    }
                }
                return foundControl;
            };
            return Message;
        }());
        messaging.Message = Message;
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Message.js.map
